export default __webpack_public_path__ + "img/Montserrat-Medium_d42dad2.woff";